import React from 'react';
import { useRecoilState } from 'recoil';
import Call from '../Call/Call';
import './Stage.css';
import ViewMode from '../../Constants/viewModes'
import ParticipantScreenShareGrid from '../ParticipantScreenShareGrid/ParticipantScreenShareGrid';
import SingleParticipantView from '../SingleParticipantView/SingleParticipantView';
import { teacherScreenViewState } from '../../state/viewModeAtom';
import SidePanel from '../SidePanel/SidePanel';

function Stage () {
  const [viewMode] = useRecoilState(teacherScreenViewState);

  return (
    <div className="stage-container">
      <div className="view-section">
        {(() => {
          switch (viewMode) {
            case ViewMode.CALL:
              return <Call />;
            case ViewMode.GRID:
              return <ParticipantScreenShareGrid />;
            case ViewMode.SINGLE:
              return <SingleParticipantView />;
            default:
              return null;
          }
        })()}
      </div>
        <SidePanel />
    </div>
  )
}

export default Stage;
